import { render, staticRenderFns } from "./DeviceCard.vue?vue&type=template&id=57ec7066&scoped=true&"
import script from "./DeviceCard.vue?vue&type=script&lang=js&"
export * from "./DeviceCard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceCard.vue?vue&type=style&index=0&id=57ec7066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ec7066",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VList,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VRow})
